/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import {
  NavBarWrapper,
  NavBarInput,
  NavBarUser,
  UserInfo,
  NavBarFilterContainer,
  NavBarFilterSelect,
  NavBarFilterOption,
  Profile,
} from './NavBar.styled'

import { ProfilePicture, Flex } from '../../styling/GlobalStyles'
import Chevron from '../../assets/icons/Chevron'
import Avatar from '../../assets/images/profileAvatar.png'
import { NavBarSearchIcon } from '../../assets/icons/NavBarSearchIcon'
import useAuth from '../../hooks/useAuth'
import { useSelector } from 'react-redux'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { RootState } from 'store'
import { FilterIcon } from 'assets/icons/FilterIcon'
import { VerticalSeparatorIcon } from 'assets/icons/VerticalSeparatorIcon'
import { UserOptions } from './UserOptions'
import { createPortal } from 'react-dom'
import { Heading3, OtherText } from 'styling/Typography'
import { Filter } from '../Filter/Filter'
import { IFilter } from 'components/Filter/SingleFilter'

export const NavBar = ({ params, st, input, placeholder, setParams, limit, searchFields, queryName, defaultValue, filterClick, filterOptions, enableTemporaryManualClosing, visibleFilterOverflow }: INavBar) => {
  const { isSidebarOpen } = useSelector((store: RootState) => store.globals)
  const { user, logout } = useAuth()
  const [show, setShow] = useState(false)
  const [openFilter, setOpenFilter] = useState(false)
  const [profileImage, setProfileImage] = useState<any>()
  const [query, setQuery] = useState<string>(defaultValue)
  useEffect(() => {
    if (user?.getImagePresignedUrl) {
      setProfileImage(user?.getImagePresignedUrl)
    }
  })

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setParams((prev: any) => {
      const copy = { ...prev }
      if (queryName) {
        copy[queryName] = query
      } else {
        copy.q = query
      }
      copy.page = 1
      copy.limit = limit ? limit : 30
      if (searchFields) {
        copy.searchFields = searchFields
      }
      return copy
    })
  }

  const handleClearQuery = () => {
    setQuery('')
    setParams((prev: any) => {
      const copy = { ...prev }
      if (queryName) {
        copy[queryName] = ''
      }
      copy.q = ''
      return copy
    })
  }

  useEffect(() => {
    if (!user) {
      logout()
    }
  }, [])



  return (
    <NavBarWrapper st={st} sidebar={isSidebarOpen}>
      <form onSubmit={handleSubmit}>
        <NavBarInput>
          <div className='icons' style={{ userSelect: 'none' }} >
            {(filterClick || filterOptions) && <>
              <FilterIcon onClick={filterClick ?? (() => setOpenFilter(p => !p))} />
              {input && <VerticalSeparatorIcon />}
            </>}
            {input && <NavBarSearchIcon />}
          </div>
          {input && <>
            <input value={query} type='text' placeholder={placeholder} onChange={handleInput} />
            {query && (
              <Flex center onClick={handleClearQuery}>
                <CloseIcon black />
              </Flex>
            )}
          </>}
        </NavBarInput>
      </form>

      <NavBarUser className='user' >
        <Profile>
          <UserInfo>
            <Heading3>
              {user?.firstName} {user?.lastName}
            </Heading3>
            <OtherText>{user?.currentContract?.role?.name}</OtherText>
          </UserInfo>

          <ProfilePicture onClick={() => setShow(!show)}>
            <img
              src={profileImage ?? Avatar}
              alt='user-img'
              onError={({ currentTarget }) => (currentTarget.src = Avatar)}
            />
          </ProfilePicture>
        </Profile>
        {show && createPortal(
          <UserOptions setShow={setShow} />,
          document.body
        )}
      </NavBarUser>
      {openFilter && <Filter enableTemporaryManualClosing={enableTemporaryManualClosing} closeFilter={() => setOpenFilter(false)} filterOptions={filterOptions} params={params} setParams={setParams} visibleFilterOverflow={visibleFilterOverflow} />}
    </NavBarWrapper>
  )
}


interface INavBar {
  input?: boolean
  placeholder?: string
  handleChange?: () => void
  handleSubmit?: () => void
  setParams?: React.Dispatch<React.SetStateAction<any>>
  limit?: number
  searchFields?: string[]
  queryName?: string
  defaultValue?: string
  st?: string
  filterClick?: () => void
  filterOptions?: IFilter[];
  params?: any //TODO tip
  enableTemporaryManualClosing?: boolean
  visibleFilterOverflow?: boolean
}